import { Navigate, useRoutes } from 'react-router';
import HomePage from './pages/HomePage/HomePage';
import UserDashboardPage from './pages/UserDashboardPage/UserDashboardPage';
import UserProfilePage from './pages/UserProfilePage/UserProfilePage';
import PartnerGamesPage from './pages/PartnerGamesPage/PartnerGamesPage';
import PartnerDashboardPage from './pages/PartnerDashboardPage/PartnerDashboardPage';
import PartnerProfilePage from './pages/PartnerProfilePage/PartnerProfilePage';
import UserPassPage from './pages/UserPassPage/UserPassPage';
import UserOrderPage from './pages/UserOrderPage/UserOrderPage';

function App() {
  let routes = useRoutes([
    // {
    //   path: '*',
    //   element: <NotFound />,
    // },
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/cabinet/user/dashboard',
      element: <UserDashboardPage />,
    },
    {
      path: '/cabinet/user/profile',
      element: <UserProfilePage />,
    },
    {
      path: '/cabinet/partner/dashboard',
      element: <PartnerDashboardPage />,
    },
    {
      path: '/cabinet/partner/profile',
      element: <PartnerProfilePage />,
    },
    {
      path: '/cabinet/partner/games',
      element: <PartnerGamesPage />,
    },
    {
      path: '/cabinet/user/pass',
      element: <UserPassPage />,
    },
    {
      path: '/order/:transactionId',
      element: <UserOrderPage />,
    },
    // {
    //   path: '/admin/banner/update/:slug',
    //   element: (
    //     <AdminLayout>
    //       <AdminBannerUpdate />
    //     </AdminLayout>
    //   ),
    // },
  ]);

  return routes;
}

export default App;
